import { useEffect, useRef } from 'react';

/**
 * Run an async callback immediately and then on a fixed interval.
 * Cleans up the interval on unmount and prevents overlapping executions.
 */
export default function useAutoRefresh(callback, deps = [], intervalMs = 60000) {
  const isRunningRef = useRef(false);

  useEffect(() => {
    let isMounted = true;

    const tick = async () => {
      if (isRunningRef.current || !isMounted) return;
      isRunningRef.current = true;
      try {
        await callback();
      } catch (err) {
        console.error(err);
      } finally {
        isRunningRef.current = false;
      }
    };

    tick();
    const id = setInterval(tick, intervalMs);

    return () => {
      isMounted = false;
      clearInterval(id);
      isRunningRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, intervalMs, ...deps]);
}